import { Select } from "antd";
import React, { useEffect, useState, useRef } from "react";
import { IoMdArrowDropdown } from "react-icons/io";
import TextComponent from "../textComponent/TextComponent";
import styles from "./Dropdown.module.css";
import "./Dropdown.css";
import { MdDoNotDisturb } from "react-icons/md";

const Dropdown = (props) => {
  const wrapperRef = useRef(null);

  const getInitialValue = () => {
    // If user passed object → return value
    if (typeof props.value === "object") return props.value?.value;
    return props.value;
  };

  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(getInitialValue());

  // Sync parent value to dropdown state
  useEffect(() => {
    setSelectedValue(getInitialValue());
  }, [props.value]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleChange = (value) => {
    setSelectedValue(value);

    // Find selected full object
    const selectedOption = props?.options.find(
      (option) => option.value === value,
    );

    // Send full option object to parent
    props?.onChange?.(selectedOption);

    setIsOpen(false);
  };

  return (
    <div className={`${styles.main_input} ${props?.className}`}>
      <text className={`${styles.label} ${props?.labelClass}`}>
        <TextComponent>{props?.label}</TextComponent>
      </text>

      <div className={styles.input} style={props.inputStyle} ref={wrapperRef}>
        <Select
          disabled={props?.disabled}
          value={selectedValue}
          placeholder={props?.placeholder || null}
          open={isOpen}
          suffixIcon={null}
          style={{ fontFamily: "Urbanist-regular" }}
          dropdownStyle={{ fontFamily: "Urbanist-regular" }}
          className={`${styles.inner_input} ${props?.inputClass}`}
          onChange={handleChange}
          onDropdownVisibleChange={(open) => setIsOpen(open)}
          onClick={(prev) => !prev}
          options={props?.options?.map((option) => ({
            label: option.value,
            value: option.value,
          }))}
        />

        <div
          className={
            props?.disabled
              ? styles.rightIconDown
              : isOpen
                ? styles.rightIconUp
                : styles.rightIconDown
          }
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen((prev) => !prev);
          }}
        >
          {props?.disabled ? (
            <MdDoNotDisturb size={15} color="red" />
          ) : (
            <IoMdArrowDropdown />
          )}
        </div>
      </div>

      {props.error && (
        <TextComponent
          style={{
            color: "red",
            fontSize: 12,
            marginTop: 5,
          }}
        >
          {props.error}
        </TextComponent>
      )}
    </div>
  );
};

export default Dropdown;
